import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from '@prio365/prio365-react-library';
import { ProjectId } from '../../../../models/Types';

import { Message } from '../../../../models/Message';
import AssignMessageModal from '../MessageDisplay/AssignMessageModal';

interface AssignMailsButtonProps {
  projectId: ProjectId;
  selectedMessages: Message[];
}

export const AssignMailsButton: React.FC<AssignMailsButtonProps> = (props) => {
  //#region ------------------------------ Defaults
  const { selectedMessages, projectId } = props;
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const [visible, setVisible] = useState(false);
  //#endregion

  //#region ------------------------------ Methods / Handlers

  const onAssign = async () => {
    setVisible(true);
  };
  //#endregion

  //#region ------------------------------ Components
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <>
      <Tooltip
        overlay={
          selectedMessages.length > 200
            ? t('mail:navigationBar.toManySelected')
            : undefined
        }
        placement="bottom"
      >
        {
          <Button
            type="default"
            onClick={onAssign}
            iconProp={['fal', 'user-plus']}
            disabled={selectedMessages.length > 200}
          >
            <span>{t('mail:navigationBar.assignMessages')}</span>
          </Button>
        }
      </Tooltip>

      {visible && (
        <AssignMessageModal
          projectId={projectId}
          assignMessageModalVisible={visible}
          setAssignMessageModalVisible={setVisible}
          selectedMessages={selectedMessages}
        />
      )}
    </>
  );
};

export default AssignMailsButton;
